import { React, PT } from '@gasbuddy/react';
import { Grid, Divider } from 'semantic-ui-react';
import { PoiLocation, PoiBrand } from '../..';

export const WexMatcherSingle = ({ stationDetails }) => {
  const stringPlace = `${stationDetails.address.line_1} ${stationDetails.address.locality} ${stationDetails.address.region}`;
  return (
    <Grid.Row>
      <Grid.Column width={3} textAlign="center">
        <PoiLocation poi={stationDetails} />
        <Divider horizontal />
        <a
          href={`https://www.google.com/maps/search/${encodeURIComponent(stringPlace)}`}
          rel="noopener noreferrer"
          target="_blank"
        >
          Open In Google Maps
        </a>
      </Grid.Column>
      { stationDetails.brandings
        ? (
          <Grid.Column>
            <PoiBrand brands={stationDetails.brandings} />
          </Grid.Column>
        ) : ''
      }
    </Grid.Row>
  );
};

WexMatcherSingle.defaultProps = {};

WexMatcherSingle.propTypes = {
  stationDetails: PT.shape({
    brandings: PT.arrayOf(PT.shape({
      brand_id: PT.isnumber,
      branding_type: PT.string,
      image_url: PT.string,
    })),
  }).isRequired,
};
